import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import "../../static/font-awesome-4.7.0/css/font-awesome.css"

import { Header } from "../Header"
import "./index.scss"

export const Layout = ({ children }) => {
    const data = useStaticQuery(graphql`
        query SiteTitleQuery {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `)

    return (
        <div style={{ margin: "1em" }}>
            <Header data={data} />
            <div className="main-wrapper">
                <main>{children}</main>
                <footer>© {new Date().getFullYear()}</footer>
            </div>
        </div>
    )
}
